import axios from "axios";
import { AuthService } from "../services/AuthService";
import { HmacSignatureUtilities } from "../services/hmac-encryption-decryption";

export const AxiosInstance = axios.create();

AxiosInstance.interceptors.request.use(
    req => {
        var isTokenExpired = AuthService.isTokenExpired();        
        if (req.method === "post" || req.method === "put") {
            req.headers.FalkonSignature = HmacSignatureUtilities.signData(req.data)
        }
        if (isTokenExpired && req.method !== "OPTIONS") {
            return AuthService.refreshToken().then(res => {
                req.headers.authorization = `Bearer ${AuthService.getToken().access_token}`;
                return Promise.resolve(req);
            }).catch(err => { console.log(err); });
        } else {
            var token = AuthService.getToken();
            if (!!token && !!token.access_token && req.method !== "OPTIONS")
                req.headers.authorization = `Bearer ${token.access_token}`;
            return req;
        }

    },
    error => {
        return Promise.reject(error);
    }
);

AxiosInstance.interceptors.response.use(
    response => {
        const signature = response.headers['falkonsignature'];
        if (!signature) {
            return response;
        }

        const valid = HmacSignatureUtilities.verifySignature(response.data, signature);

        if (valid) {
            return response;
        } else {
            return {
                ...response,
                status: 400,
                data: {
                    success: false,
                    error: "Signature verification process failed",
                    payload: null,
                },
            };
        }
    },
    error => {
        console.log(error);

        if (error && error.response && (error.response.status === 401)) {
            AuthService.logout();
        }

        return Promise.reject(error);
    }
);
